// extracted by mini-css-extract-plugin
module.exports = {"buttonReg":"registerButton-module--buttonReg--TUFC3"};